/** Grup penceresindeki ikincil metinlerin (statü, not, ipucu) ortak stili. */
export const mutedTextStyle = { fontSize: 12, color: '#8B948F' };

/** Satır sonundaki kısa not; dar alanda alt satıra kırılmaz. */
export const mutedNoteStyle = { ...mutedTextStyle, whiteSpace: 'nowrap' };
